import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gbpCurrency',
  standalone: true
})
export class GbpCurrencyPipe implements PipeTransform {
  transform(value: string): string {
    const num = parseFloat(value);
    if (isNaN(num)) {
      return '';
    }

    if (num >= 1) {
      const currency = new CurrencyPipe('en-GB');
      return `${currency.transform(num, 'GBP')}`;
    }

    return `${Math.round(num * 100)}p`;
  }
}
